import React from "react";
import { Box, Skeleton, Typography, Container, Grid } from "@mui/material";

const SwapRebalanceFinalSkeleton = () => (
  <Container disableGutters maxWidth="100%" sx={{ marginTop: 2 }}>
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Box sx={{ width: "40%" }}>
            <Box
              sx={{
                marginBottom: 1,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Skeleton variant="text" width={200} height={32} />
              <Skeleton variant="rectangular" width={120} height={36} sx={{ mb: 1 }} />
            </Box>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12}>
        {/* Success Alert Skeleton */}
        <Skeleton variant="rectangular" width={500} height={48} sx={{ mb: 2 }} />
        {/* Table Skeleton */}
        <Box sx={{ display: "flex", flexDirection: "row", width: "60%" }}>
          <Box sx={{ width: "100%" }}>
            {/* Table Header */}
            <Box sx={{ display: "flex", mb: 1 }}>
              <Skeleton variant="text" width={120} height={28} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={160} height={28} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={120} height={28} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={120} height={28} />
            </Box>
            {/* Table Rows */}
            {[...Array(8)].map((_, i) => (
              <Box key={i} sx={{ display: "flex", mb: 1 }}>
                <Skeleton variant="text" width={120} height={24} sx={{ mr: 2 }} />
                <Skeleton variant="text" width={160} height={24} sx={{ mr: 2 }} />
                <Skeleton variant="text" width={120} height={24} sx={{ mr: 2 }} />
                <Skeleton variant="text" width={120} height={24} />
              </Box>
            ))}
          </Box>
        </Box>
      </Grid>
    </Grid>
  </Container>
);

export default SwapRebalanceFinalSkeleton; 